import(/* webpackMode: "eager", webpackExports: ["OracleClient"] */ "/vercel/path0/app/generator/oracle/OracleClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
